module.exports = "/_next/static/videos/easiConnectVideo-0f671a759781b703497cc1c77537489d.mp4";